var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import MAXIMUM_CUSTOM_REWARD_CHARACTERS from "@irati/reward/constants/maximumCustomRewardName";
import Card from "@irati/ui/src/Layout/Card";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Headings";
import history from "@irati/utils/history";
import { rewardTracking } from "@irati-tracking/reward";
import { customRewardNameSchema } from "../../helpers/validation/schema";
import { Input, Button } from "./styled";
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleInputChange = function (customRewardName) {
            _this.setState({ customRewardName: customRewardName });
        };
        _this.handleButtonClick = function () {
            rewardTracking.rewardsTabAddCustomRewardStart();
            var customRewardName = _this.state.customRewardName;
            history.push({
                pathname: "/reward/create",
                state: { customRewardName: customRewardName }
            }, _this.context);
        };
        return _this;
    }
    Sidebar.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, intl = _a.intl;
        var customRewardName = this.state.customRewardName;
        return (React.createElement(Card, null,
            React.createElement(H4, null,
                React.createElement(FormattedMessage, { id: "reward.customReward.giveNameTitle" })),
            React.createElement(Input, { name: "custom-reward", type: "custom-reward", value: customRewardName, placeholder: formatMessage({ id: "reward.customReward.input.placeholder" }), onChange: this.handleInputChange, validation: customRewardNameSchema(intl, MAXIMUM_CUSTOM_REWARD_CHARACTERS) }),
            React.createElement(Button, { primary: true, large: true, onClick: this.handleButtonClick },
                React.createElement(FormattedMessage, { id: "reward.detail.btnReward.label" }))));
    };
    Sidebar.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return Sidebar;
}(PureComponent));
export default injectIntl(Sidebar);
